import { useSearchParams } from "react-router-dom";
import CmsIdentidadEditor from "./CmsIdentidadEditor";
import CmsHomeEditor from "./CmsHomeEditor";

const TABS = [
  { id: "identidad", label: "Identidad" },
  { id: "hero", label: "HERO" },
  { id: "medios", label: "Medios" },
];

export default function CmsIdentidadPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab") || "identidad";
  const tab = TABS.some((t) => t.id === raw) ? raw : "identidad";

  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <h2 className="font-display text-3xl font-black">Identidad</h2>
        <p className="text-sm text-brand-dark/55 mt-1">
          Marca institucional, video del HERO y playlist de Medios (Centro de inteligencia).
        </p>
      </div>

      <nav className="flex flex-wrap gap-1 border-b border-brand-soft">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setParams({ tab: t.id })}
            className={`px-4 py-2.5 text-sm ${
              tab === t.id
                ? "border-b-2 border-brand-primary font-bold text-brand-primary"
                : "text-brand-dark/55 hover:text-brand-dark"
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {tab === "identidad" ? <CmsIdentidadEditor /> : null}
      {tab === "hero" ? <CmsHomeEditor variant="hero" embedded /> : null}
      {tab === "medios" ? <CmsHomeEditor variant="medios" embedded /> : null}
    </div>
  );
}
